import Tween from "tween.ts";
import Animation from "../Animation";


export default class RotateCircleAnim extends Animation {
  constructor(onUpdate: (a: number) => void, rotationCount: number, onComplete: () => void) {
    super();
    const a = { radian: 0 };
    const targetRadian = rotationCount * (Math.PI * 2)
    new Tween.Tween({ ...a })
      .to({ radian: targetRadian }, 3000)
      .delay(600)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((a) => onUpdate(a.radian))
      .onComplete(() => onComplete())
      .start()
  }
}